import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useBreakPoints from "../../hooks/useBreakPoints";
import debounce from "lodash/debounce";
import moment from "moment";
import InvoicePdfFormat from "./invoiceFormat";
const OrderDetails = () => {
  const { isMobile } = useBreakPoints();
  const params = useParams();
  const navigate = useNavigate();
  const [singleOrderDetails, setSingleOrderDetails] = useState();
  console.log('singleOrderDetails_f: ', singleOrderDetails);
  const [loading, setloading] = useState(true);
  const [counter, setCounter] = useState(0);
  let invoiceTemplate = JSON.parse(localStorage?.getItem("invoiceTemplate"));
  console.log("invoiceTemplate: ", invoiceTemplate);

  const debouncedApiCall = useCallback(
    debounce((id) => {
      callOrderDetailsByIdApi(id);
    }, 1000),
    []
  );

  const signalCall = (id) => {
    const socket = new WebSocket(`wss://api.k9interior.com/ws/AdminNotify/`);
    socket.onopen = () => {
      console.log("WebSocket connection opened");
    };
    // socket.onmessage = (e) => {
    //   console.log("Received message:", e.data);
    //   let received_data_as_object = e.data;
    //   if (received_data_as_object.split("_")[0] === "Reload") {
    //     callOrderDetailsByIdApi(params?.id);
    //   }
    // };
    socket.onmessage = (event) => {
      console.log("eventsocket: ", event);
      const data = event.data;
      console.log("dataSocket: ", data);
      if (data === "Reload") {
        // Trigger a re-fetch of product data
        setTimeout(() => {
          callOrderDetailsByIdApi(id);
        }, 5000);
        // debouncedApiCall(params?.id);
      }
    };
    socket.onclose = (e) => {
      console.error("WebSocket closed unexpectedly", e);
    };
    // Clean up the WebSocket connection when the component unmounts
    return () => {
      socket.close();
    };
  };

  const callOrderDetailsByIdApi = useCallback(async () => {
    setloading(true);
    try {
      let formData = new FormData();
      formData.append("orderedProductId", params?.id);
      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}orderdetailbyorderedproduct?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setSingleOrderDetails(data?.orderedProductList?.[0]);

            setloading(false);
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });

      //   const apiCall = await getOrderDetailsIdApi(formData);
      //   if (apiCall.status) {
      //     setLoading(false);
      //     setSingleOrderDetails(apiCall?.orderedProductList?.[0]);
      //   } else {
      //     setLoading(false);
      //     toast.error(apiCall?.message);
      //   }
    } catch (error) {
      console.log(error);
      setloading(false);
    }
  }, [params?.id]);

  const callCancelOrderDetail = async (e) => {
    e.preventDefault();
    setloading(true);

    let formData = new FormData();
    formData.append("orderedProductId", params?.id);

    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}cancelorder?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          setloading(false);
          navigate("/");
          toast.success("Order Cancel Successfully!");
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  useEffect(() => {
    signalCall(params?.id);
    callOrderDetailsByIdApi(params?.id);
  }, [params?.id]);

  return (
    <>
      <Breadcrumb
        mainTitle={"Order Details"}
        title={"Order Details"}
        subTitle={"Home"}
      />

      <section className="container ">
        <div
          style={{
            padding: 10,
          }}
        >
          <div
            className="accordion -simple row y-gap-20 js-accordion"
            style={{ gap: "10px 0px" }}
          >
            <div className={`${isMobile ? "col-12" : "col-6"}`}>
              <div
                className={`accordion__item px-20 py-15 border-1 rounded-12 
                       is-active
                    `}
                style={{ minHeight: 184 }}
              >
                <div className="accordion__button d-flex items-center justify-between">
                  <div className=" text-16 text-dark-1">
                    <p
                      style={{
                        fontSize: 18,
                        color: "black",
                        fontWeight: 600,
                      }}
                    >
                      Delivery Address
                    </p>
                  </div>
                </div>

                <div
                  className="accordion__content"
                  style={{
                    maxHeight: 439,
                    overflow: "auto",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      padding: "15px 0",
                      borderBottom: "1px solid #e0e0e0",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontWeight: "bold",
                            marginRight: "10px",
                          }}
                        >
                          {singleOrderDetails?.customerDetails?.customerName}
                        </span>
                        <span
                          style={{
                            backgroundColor: "#e0e0e0",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            marginRight: "10px",
                          }}
                        >
                          HOME
                        </span>
                        <span
                          style={{
                            color: "#666",
                            marginRight: "10px",
                          }}
                        >
                          {singleOrderDetails?.customerDetails?.customerMobile}
                        </span>
                      </div>
                    </div>
                    <span
                      style={{
                        color: "#666",
                        fontSize: "14px",
                        flex: 1,
                        paddingLeft: 0,
                        width: "90%",
                      }}
                    >
                      {
                        singleOrderDetails?.shippingAddress?.[0]
                          ?.customerAddress
                      }
                      ,{singleOrderDetails?.shippingAddress?.[0]?.customerCity},
                      {singleOrderDetails?.shippingAddress?.[0]?.customerState},
                      {
                        singleOrderDetails?.shippingAddress?.[0]
                          ?.customerPincode
                      }
                      ,
                      {
                        singleOrderDetails?.shippingAddress?.[0]
                          ?.customerCountry
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${isMobile ? "col-12" : "col-6"}`}>
              <div
                className={`accordion__item px-20 py-15 border-1 rounded-12 
                       is-active
                    `}
                style={{ minHeight: 184 }}
              >
                <div
                  className="accordion__button d-flex items-center justify-between"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: isMobile && "column",
                  }}
                >
                  <div className=" text-16 text-dark-1">
                    <p
                      style={{
                        fontSize: 18,
                        color: "black",
                        fontWeight: 600,
                      }}
                    >
                      Order Details
                    </p>
                  </div>
                  {/* {singleOrderDetails?.lastTrackedStatus === "delivered" && ( */}
                  <button
                    className="jost-font"
                    disabled={loading}
                    onClick={() => {
                      setCounter(1);
                    }}
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px 10px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    Download Invoice
                  </button>
                  {/*  )} */}
                  {singleOrderDetails?.lastTrackedStatus !== "delivered" && (
                    <button
                      className="jost-font"
                      onClick={(e) => {
                        callCancelOrderDetail(e);
                      }}
                      style={{
                        backgroundColor: "#00264d",
                        color: "white",
                        border: "none",
                        padding: "15px 10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      {(
                        singleOrderDetails?.lastTrackedStatus === "pending" ||
                        !singleOrderDetails?.lastTrackedStatus ||
                        singleOrderDetails?.lastTrackedStatus === "confirm" ||
                        singleOrderDetails?.lastTrackedStatus === "dispatch")
                        ? "Cancel Order"
                        : "Return Order"}
                    </button>
                  )}
                </div>

                <div
                  className="accordion__content"
                  style={{
                    maxHeight: 439,
                    overflow: "auto",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      padding: "15px 0",
                      borderBottom: "1px solid #e0e0e0",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <div className="jost-font">Order Id : {params?.id}</div>
                      <div className="jost-font ">
                        Order Date :{" "}
                        {singleOrderDetails?.orderDetails?.orderDate
                          ? moment(
                            singleOrderDetails?.orderDetails?.orderDate,
                            "YYYY-MM-DD"
                          ).format("DD  MMM   YY")
                          : ""}
                      </div>
                      <div
                        className="jost-font"
                        style={{ textTransform: "capitalize" }}
                      >
                        Order Status :{" "}
                        {singleOrderDetails?.lastTrackedStatus || "Pending"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div
                className={`accordion__item px-20 py-15 border-1 rounded-12 
                       is-active
                    `}
                style={{ minHeight: 184 }}
              >
                <div className="accordion__button d-flex items-center justify-between">
                  <div className=" text-16 text-dark-1">
                    <p
                      style={{
                        fontSize: 18,
                        color: "black",
                        fontWeight: 600,
                      }}
                    >
                      Product Details
                    </p>
                  </div>
                </div>

                <div
                  className="accordion__content"
                  style={{
                    maxHeight: 439,
                    overflow: "hidden auto",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "15px 0",
                      borderBottom: "1px solid #e0e0e0",
                      overflow: "hidden",
                      justifyContent: "space-between",
                    }}
                    className="row"
                  >
                    <div className="col-md-5 d-flex justify-content-center align-items-center gap-2">
                      {JSON.parse(
                        singleOrderDetails?.productDetails?.variantDetail?.variantImageGallery?.replace(
                          /'/g,
                          '"'
                        ) || "[]"
                      )?.length > 0 && (
                          <img
                            src={
                              JSON.parse(
                                singleOrderDetails?.productDetails?.variantDetail?.variantImageGallery?.replace(
                                  /'/g,
                                  '"'
                                )
                              )[0]
                            }
                            alt="Ring"
                            style={{
                              width: "250px",
                              height: "250px",
                              objectFit: "contain",
                              borderRadius: 12,
                            }}
                          />
                        )}

                      <div>
                        <div
                          className="unna-regular"
                          style={{ fontSize: 22, lineHeight: "26px" }}
                        >
                          {
                            singleOrderDetails?.productDetails?.productDetail
                              ?.productname
                          }
                        </div>

                        <div className="jost-font">
                          {
                            singleOrderDetails?.productDetails?.productDetail
                              ?.mainCategoryDetails?.mainCategoryName
                          }{" "}
                          -{" "}
                          {singleOrderDetails?.productDetails?.productDetail
                            ?.categoryDetails?.mainCategoryName &&
                            `${singleOrderDetails?.productDetails?.productDetail?.categoryDetails?.mainCategoryName}`}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-7">
                      <div className=" hh-grayBox ">
                        <div className="row justify-content-between">
                          <div
                            className={`order-tracking ${singleOrderDetails?.trackingStatusHistory?.find(
                              (er) => er?.trackingStatus === "confirm"
                            )
                                ? "completed"
                                : ""
                              }`}
                          >
                            <span className="is-complete"></span>
                            <p>
                              Ordered
                              <br />
                              <span>
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "confirm"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) => er?.trackingStatus === "confirm"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("ddd")
                                  : ""}
                                ,{" "}
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "confirm"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) => er?.trackingStatus === "confirm"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("MMMM DD")
                                  : ""}
                              </span>
                            </p>
                          </div>
                          <div
                            className={`order-tracking ${singleOrderDetails?.trackingStatusHistory?.find(
                              (er) => er?.trackingStatus === "dispatch"
                            )
                                ? "completed"
                                : ""
                              }`}
                          >
                            <span className="is-complete"></span>
                            <p>
                              Dispatch
                              <br />
                              <span>
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "dispatch"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "dispatch"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("ddd")
                                  : ""}
                                ,{" "}
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "dispatch"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "dispatch"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("MMMM DD")
                                  : ""}
                              </span>
                            </p>
                          </div>
                          <div
                            className={`order-tracking ${singleOrderDetails?.trackingStatusHistory?.find(
                              (er) => er?.trackingStatus === "arrivalToday"
                            )
                                ? "completed"
                                : ""
                              }`}
                          >
                            <span className="is-complete"></span>
                            <p>
                              Arriving Today
                              <br />
                              <span>
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "arrivalToday"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "arrivalToday"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("ddd")
                                  : ""}
                                ,{" "}
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "arrivalToday"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "arrivalToday"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("MMMM DD")
                                  : ""}
                              </span>
                            </p>
                          </div>
                          <div
                            className={`order-tracking ${singleOrderDetails?.trackingStatusHistory?.find(
                              (er) => er?.trackingStatus === "delivered"
                            )
                                ? "completed"
                                : ""
                              }`}
                          >
                            <span className="is-complete"></span>
                            <p>
                              Delivered
                              <br />
                              <span>
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "delivered"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "delivered"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("ddd")
                                  : ""}
                                ,{" "}
                                {singleOrderDetails?.trackingStatusHistory?.find(
                                  (er) => er?.trackingStatus === "delivered"
                                )
                                  ? moment(
                                    singleOrderDetails?.trackingStatusHistory?.find(
                                      (er) =>
                                        er?.trackingStatus === "delivered"
                                    )?.updateStatusDate,
                                    "YYYY-MM-DD"
                                  ).format("MMMM DD")
                                  : ""}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {counter === 1 && (
        <InvoicePdfFormat
          setCounter={setCounter}
          data={invoiceTemplate}
          orderDetails={singleOrderDetails}
        />
      )}
    </>
  );
};

export default OrderDetails;
